export class ProspectoApi {

    async representantes() {
        try {
            const response = await axios.get('/adm/prospecto/representante')

            return response.data;
        } catch (error) {
            console.error('Error get consultants:', error);
            throw error;
        }
    }

    async verificarIE(uf, ie) {
        try {
            const response = await axios.get('/adm/prospecto/verificar-inscricao', {
                params: {
                    uf,
                    inscricao: ie
                }
            })

            return response.data;
        } catch (error) {
            console.error('Error in verify IE:', error);
            throw error;
        }
    }

    async manualConsultLemit(id) {
        try {
            const response = await axios.get(`/adm/prospecto/${id}/manual-consult-lemit`)

            return response.data;
        } catch (error) {
            console.error('Error in manual consultant:', error);
            throw error;
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/api/Prospecto/ProspectoApi.js